import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	CardDescription,
} from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { SectionHeader } from '../SectionHeader'
import { AIPromptCard } from '../AIPromptCard'
import { aiPrompt } from '../constants'
import { useTranslation } from '@/hooks/useTranslation'

export const UserIdentificationSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="user-identification" className="mb-16">
			<SectionHeader id="user-identification">
				{t('docs.userIdentification.title')}
			</SectionHeader>

			<AIPromptCard
				title={t('docs.userIdentification.aiPrompt.title')}
				prompt={aiPrompt}
			/>

			<Card className="mb-8 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle className="text-xl font-semibold">
						{t('docs.userIdentification.identifyUsers.title')}
					</CardTitle>
					<CardDescription className="dark:text-gray-400">
						{t('docs.userIdentification.identifyUsers.description')}
					</CardDescription>
				</CardHeader>
				<CardContent className="text-gray-700 dark:text-gray-300 space-y-4">
					<p>
						{t('docs.userIdentification.identifyUsers.intro')}
					</p>

					<div className="grid md:grid-cols-2 gap-4">
						<div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-700">
							<h4 className="font-semibold text-green-800 dark:text-green-200 mb-2">
								✅ {t('docs.userIdentification.benefits.title')}
							</h4>
							<ul className="text-sm text-green-700 dark:text-green-300 space-y-1">
								<li>
									• <strong>{t('docs.userIdentification.benefits.item1.label')}</strong>{' '}
									{t('docs.userIdentification.benefits.item1.text')}
								</li>
								<li>
									• <strong>{t('docs.userIdentification.benefits.item2.label')}</strong>{' '}
									{t('docs.userIdentification.benefits.item2.text')}
								</li>
								
							</ul>
						</div>
						<div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-700">
							<h4 className="font-semibold text-blue-800 dark:text-blue-200 mb-2">
								📋 {t('docs.userIdentification.useCases.title')}
							</h4>
							<ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1">
								<li>
									• <strong>{t('docs.userIdentification.useCases.item1.label')}</strong>{' '}
									{t('docs.userIdentification.useCases.item1.text')}
								</li>
								<li>
									• <strong>{t('docs.userIdentification.useCases.item2.label')}</strong>{' '}
									{t('docs.userIdentification.useCases.item2.text')}
								</li>
								<li>
									• <strong>{t('docs.userIdentification.useCases.item3.label')}</strong>{' '}
									{t('docs.userIdentification.useCases.item3.text')}
								</li>
								<li>
									• <strong>{t('docs.userIdentification.useCases.item4.label')}</strong>{' '}
									{t('docs.userIdentification.useCases.item4.text')}
								</li>
							</ul>
						</div>
					</div>
				</CardContent>
			</Card>

			<Card className="mb-8 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle className="text-xl font-semibold flex items-center gap-2">
						<span className="flex items-center justify-center w-6 h-6 bg-primary/10 text-primary rounded-full text-sm font-bold">
							1
						</span>
						{t('docs.userIdentification.step1.title')}
					</CardTitle>
				</CardHeader>
				<CardContent className="text-gray-700 dark:text-gray-300 space-y-4">
					<p>
						{t('docs.userIdentification.step1.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs font-mono">
							identify
						</code>{' '}
						{t('docs.userIdentification.step1.instruction.suffix')}
					</p>
					<CodeBlock
						code={`// Call this after a user logs into your site
window.feedbask.identify({
  userId: 'user_12345',        // Required: A stable, unique ID from your system
  name: 'Ada Lovelace',        // Optional: Pre-fills name field
  email: 'ada@example.com',    // Optional: Pre-fills email field

  // You can add any other custom properties
  plan: 'premium',
  createdAt: '2023-10-27T10:00:00Z',
  department: 'Engineering'
});`}
						language="javascript"
						copyLabel={t('docs.userIdentification.step1.copyLabel')}
						copyMessage={t('docs.userIdentification.step1.copyMessage')}
					/>
				</CardContent>
			</Card>
		</section>
	)
}